module.exports = __webpack_public_path__ + "static/media/club.3407eaaa.svg";